import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class DescuentoApi {
    
    static activar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/descuento/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/descuento/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getDescuentoList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/descuento?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getDescuento(id, token ) {  
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/descuento/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static getCodigosList(id, token ) {  
         return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/descuentocupones/listaCupones/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(descuento, token ) {          
      let descuentoEnvio = Object.assign({}, descuento);
		let comando="POST";
		if (descuentoEnvio.id > 0) {
			comando="PUT";			
		} 
		descuentoEnvio=JSON.stringify(descuentoEnvio);
		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/descuento/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: descuentoEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getDescuentoCombo(token ) {

		return $.ajax({
 			headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/descuento/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}